import { Commit } from '@/store/types'
import { AccountApi, StoreError } from '@/store/modules/account/types'
import { getEnvironments } from '@/environments'
import { eraseCookie, getCookie, setCookie } from './CookieService'

export interface UserCredentials {
  password: string;
  email: string;
}

export interface AccountInterface {
  sendCredentials(credentials: UserCredentials): Promise<Commit<AccountApi | StoreError>>
  logout(): Promise<Commit<AccountApi>>
  passwordUpdate(password: string): Promise<Commit<string>>
  alertUpdate(alertaMovil: string, alertaCorreo: string): Promise<Commit<any>>
  getCookieCredentials(): Promise<Commit<AccountApi>>
}

export class AccountService implements AccountInterface {
  env = getEnvironments()
  cookieName = '__alerta_jwt__'
  tokenName = 'access_token'
  cookieTime = 30
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async alertUpdate (alertaMovil: string, alertaCorreo: string): Promise<Commit<any>> {
    const response = await fetch(`${this.apiUrl}/api/usuario/direcciones_aa`, {
      body: JSON.stringify({ telefono: alertaMovil, correo: alertaCorreo }),
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (response.status === 200) {
      const credentials = JSON.parse(getCookie(this.cookieName) || '{}')
      const newCredentials = { ...credentials, alerta_correo: alertaCorreo, alerta_movil: alertaMovil }
      setCookie(this.cookieName, JSON.stringify(newCredentials), this.cookieTime)
    }
    return {
      type: 'ALERT_UPDATED',
      payload: {
        statusCode: response.status
      }
    }
  }

  async passwordUpdate (password: string): Promise<Commit<any>> {
    const response = await fetch(`${this.apiUrl}/api/usuario/clave`, {
      body: JSON.stringify({ clave: password }),
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return {
      type: 'PASSWORD_UPDATED',
      payload: { statusCode: response.status }
    }
  }

  async getCookieCredentials () {
    const credentials = getCookie(this.cookieName)
    if (credentials) {
      return {
        type: 'ACCOUNT_LOGIN',
        payload: JSON.parse(credentials)
      }
    }
    return {
      type: 'ACCOUNT_ERROR'
    }
  }

  async logout () {
    eraseCookie(this.cookieName)
    eraseCookie(this.tokenName)
    return {
      type: 'ACCOUNT_LOGOUT'
    }
  }

  async sendCredentials ({ password = '', email = '' }: UserCredentials): Promise<Commit<AccountApi | StoreError>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/usuario/ingresar`, {
        body: JSON.stringify({ correo: email, clave: password }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      if (response.status === 200) {
        const payload = await response.json()
        setCookie(this.cookieName, JSON.stringify(payload), 30)
        setCookie(this.tokenName, payload.access_token, 30)
        return { type: 'ACCOUNT_LOGIN', payload }
      }
      return {
        type: 'ACCOUNT_ERROR',
        payload: {
          state: true,
          name: 'LOGIN_ERROR',
          message: 'Credenciales Inválidas'
        }
      }
    } catch (e) {
      return { type: 'ACCOUNT_ERROR', payload: e }
    }
  }
}
